import { render } from "./WidgetBestSellersByRevenue.vue?vue&type=template&id=48208c6b&scoped=true&ts=true"
import script from "./WidgetBestSellersByRevenue.vue?vue&type=script&lang=ts"
export * from "./WidgetBestSellersByRevenue.vue?vue&type=script&lang=ts"

import "./WidgetBestSellersByRevenue.vue?vue&type=style&index=0&id=48208c6b&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\bridge\\bridgeshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48208c6b"]])

export default __exports__